import { render, staticRenderFns } from "./sharepiclist.vue?vue&type=template&id=2d977afb&scoped=true&"
import script from "./sharepiclist.vue?vue&type=script&lang=js&"
export * from "./sharepiclist.vue?vue&type=script&lang=js&"
import style0 from "./sharepiclist.vue?vue&type=style&index=0&id=2d977afb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d977afb",
  null
  
)

export default component.exports